import React, { useMemo } from 'react'
import { Avatar, Checkbox, Form, FormInstance } from 'antd'
import { useCreateRollCall } from 'api/Event/Attendance'
import { useGetLeagueParticipants } from 'api/league/LeagueAttendance/leagueAttendance'
import Spinner from 'components/Spinner'
import { convertToUtc } from 'helper/utility'
import { failureMessage, successMessage } from 'api/global'
import { leagueAttendanceStore } from 'state/league/leagueAttendance'
import { leagueEventStore } from 'state/league/leagueEvent'
import { myStore } from 'state/store'

interface Props {
  payload: any
  form: FormInstance
  closeModal: () => void
}

const LeagueRollCallSelectAttendees: React.FC<Props> = ({ form, payload, closeModal }) => {
  const { selectedDate } = leagueAttendanceStore(store => ({ selectedDate: store.selectedDate }))
  const { leagueData } = leagueEventStore(store => ({ leagueData: store.leagueData }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)

  const leagueId: string = (leagueData as any)?._id || ''

  const { data, isLoading, isFetching } = useGetLeagueParticipants({
    leagueId,
    date: convertToUtc(selectedDate),
  })

  const { mutate: createRollCall } = useCreateRollCall()

  const participants = useMemo(() => [
    ...(data?.kids || []),
    ...(data?.guardians || []),
    ...(data?.authorizedAdults || []),
    ...(data?.dropinAttendees || []),
  ], [data])

  const onFinish = (values: any) => {
    const finalPayload = {
      ...payload,
      ...values,
      leagueId,
    }
    setModalBtnLoader(true)
    createRollCall(finalPayload, {
      onSuccess: () => {
        setModalBtnLoader(false)
        closeModal()
      },
      onError: () => {
        setModalBtnLoader(false)
      },
    })
  }

  if (isLoading || isFetching) {
    return (
      <div className="py-40px flex justify-center">
        <Spinner />
      </div>
    )
  }

  if (!participants.length) {
    return (
      <div className="flex align-center justify-center" style={{ height: '200px' }}>
        <p className="text-16 text-center">No participants found for this date</p>
      </div>
    )
  }

  return (
    <Form form={form} initialValues={{ participantIds: [] }} onFinish={onFinish}>
      <p className="text-14 text-gray mb-15px">{participants.length} participants</p>
      <Form.Item name="participantIds">
        <Checkbox.Group
          options={participants.map(p => ({
            label: (
              <div className="flex align-center ml-10px">
                <Avatar size={32}>
                  {`${p.firstName?.[0] || ''}${p.lastName?.[0] || ''}`}
                </Avatar>
                <p className="text-16 ml-10px">{`${p.firstName || ''} ${p.lastName || ''}`}</p>
              </div>
            ),
            value: p._id,
          }))}
          className="mt-20px atendeeCheckbox"
        />
      </Form.Item>
    </Form>
  )
}

export default LeagueRollCallSelectAttendees
